import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable, from } from 'rxjs';
import { ConfigurationFeature } from 'src/app/common/configuration/models/configuration';
import { ConfigurationService } from 'src/app/common/configuration/services/configuration.service';
import { AppData } from 'src/app/data-store';
import { PdaPlaceholders } from '../utils/placeholder';
import { PdaAuthService } from '../utils/Service/pda-auth.service';
import { UrlSettingsCore } from 'src/app/core/configuration/url-settings-core';
import { rejects } from 'assert';

@Injectable({
  providedIn: 'root'
})
export class CancelleriaTelematicaGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(private configService: ConfigurationService,
    private auth: PdaAuthService, private router: Router) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // let rol =  localStorage.getItem(PdaPlaceholders.pda_rol);
    // const isPdaEnabled = this.configService.isFeatureEnabled(ConfigurationFeature.JUSTICE_PDA) && rol === "true";
    // if(!isPdaEnabled) return false;
    return this.isLogged();
  }
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.isLogged();
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }

  isLogged(): Promise<boolean> {

    return new Promise(async (resolve, reject) => {
      let isLogged = await this.auth.isUserLoggedToPda();
      if(isLogged) resolve(true);
      else{
        this.router.navigate([UrlSettingsCore.URL_VISUALIZZA_WELCOME_BOARD]);
        resolve(false);
      }
    });

  }

}
